import { messaging, db } from './firebaseConfig';
import { getToken, onMessage } from 'firebase/messaging';
import { doc, updateDoc, arrayUnion } from 'firebase/firestore';

const VAPID_KEY = import.meta.env.VITE_FIREBASE_VAPID_KEY;

export const requestNotificationPermission = async (userId: string) => {
    try {
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
            console.log('Notification permission granted.');
            await saveMessagingToken(userId);
            return true;
        } else {
            console.log('Unable to get permission to notify.');
            return false;
        }
    } catch (error) {
        console.error('Error requesting notification permission:', error);
        return false;
    }
};

export const saveMessagingToken = async (userId: string) => {
    try {
        const currentToken = await getToken(messaging, { vapidKey: VAPID_KEY });
        if (currentToken) {
            console.log('FCM Token:', currentToken);
            // Save token to user document in Firestore
            const userRef = doc(db, 'users', userId);
            await updateDoc(userRef, {
                fcmTokens: arrayUnion(currentToken)
            });
        } else {
            console.log('No registration token available. Request permission to generate one.');
        }
    } catch (error) {
        console.error('An error occurred while retrieving token:', error);
    }
};

export const onMessageListener = () =>
    new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            console.log('Message received. ', payload);
            resolve(payload);
        });
    });

/**
 * MOCK: Send push notification
 * In a production app, this would be a call to a backend/Cloud Function.
 */
export const sendPushNotification = async (targetUserId: string, title: string, body: string) => {
    console.log(`[Push Service] Sending notification to ${targetUserId}:`, { title, body });

    // Simulating a backend delay
    await new Promise(resolve => setTimeout(resolve, 800));

    // For demo purposes, we can trigger a local event or update a hypothetical 'notifications' collection
    // but here we just return success to simulate the backend call.
    return { success: true, messageId: `msg-${Date.now()}` };
};
/**
 * MOCK: Send push notification to a group
 */
export const sendPushNotificationToGroup = async (userIds: string[], title: string, body: string) => {
    console.log(`[Push Service] Sending notification to group (${userIds.length} users):`, { title, body });

    // Simulating a backend delay
    await new Promise(resolve => setTimeout(resolve, 1200));

    return { success: true, count: userIds.length };
};
